import { Component, OnInit } from '@angular/core';
import confetti from 'canvas-confetti';
import { ThemeService } from './services/theme.service';
import { ThemeData } from './interfaces/theme-data.interface';

@Component({
  selector: 'app-christmas-decoration',
  templateUrl: './christmas-decoration.component.html',
  styleUrls: ['./christmas-decoration.component.css']
})
export class ChristmasDecorationComponent implements OnInit {
  themeData: ThemeData | null = null;
  isLoading: boolean = true;
  error: string | null = null;

  constructor(public themeService: ThemeService) { }

  ngOnInit(): void {
    console.log('ChristmasDecorationComponent ngOnInit called');
    this.loadThemeData();
  }

  getApiUrl(): string {
    return this.themeService.baseUrl + this.themeService.themeUrl;
  }

  hasToken(): boolean {
    return !!this.themeService.accessToken;
  }

  loadThemeData(): void {
    console.log('Loading theme data from:', this.themeService.baseUrl + this.themeService.themeUrl);
    console.log('Current themeData:', this.themeData);
    console.log('Is loading:', this.isLoading);
    
    this.themeService.getThemeData().subscribe({
      next: (data: ThemeData) => {
        console.log('Theme data loaded successfully:', data);
        console.log('is_theme_active value:', data.is_theme_active);
        this.themeData = data;
        this.isLoading = false;
        if (data && data.is_theme_active) {
          console.log('Theme is active, starting falling elements');
          this.startFallingElements();
          // Commented out hardcoded Christmas snowfall - replaced with dynamic system
          // this.startSnowfall();
        } else {
          console.log('Theme is NOT active, no decorations will show');
        }
      },
      error: (error) => {
        console.error('Error loading theme data:', error);
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        console.error('Error details:', error.error);
        
        this.error = `Failed to load theme data: Status ${error.status} - ${error.statusText || error.message || 'Unknown error'}`;
        this.isLoading = false;
        // Don't start falling elements if API fails
        // this.startFallingElements();
      }
    });
  }

  // Dynamic falling elements based on API fall_drop field (supports all festivals)
  startFallingElements(): void {
    if (!this.themeData?.fall_drop) {
      console.log('No fall_drop data available');
      return;
    }

    console.log('Starting falling elements with:', this.themeData.fall_drop);
    
    // Note: Falling elements are now handled directly in the HTML template
    // The fall_drop Lottie animation will render automatically via *ngIf="themeData.fall_drop"
    console.log('Fall drop Lottie animation loaded from API:', this.themeData.fall_drop);
  }

  // Generate array for tiled Lottie animations (100px each)
  getTiledArray(): number[] {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const tileSize = 100; // 100px per tile
    
    const tilesX = Math.ceil(screenWidth / tileSize);
    const tilesY = Math.ceil(screenHeight / tileSize);
    const totalTiles = tilesX * tilesY;
    
    return Array(totalTiles).fill(0).map((_, index) => index);
  }

  // ==================== LEGACY CHRISTMAS CODE (COMMENTED FOR REFERENCE) ====================
  // This is the old hardcoded Christmas snowfall function - kept for reference
  // Replace with dynamic system above that uses fall_drop API field
  /*
  startSnowfall() {
    const duration = 15 * 1000;
    const animationEnd = Date.now() + duration;
    let skew = 1;

    const randomInRange = (min: number, max: number) => {
      return Math.random() * (max - min) + min;
    };

    const frame = () => {
      const timeLeft = animationEnd - Date.now();
      const ticks = Math.max(2000, 500 * (timeLeft / duration));
      skew = Math.max(0.8, skew - 0.001);

      // Reduce frequency by only creating snow 30% of the time
      if (Math.random() > 0.7) {
        confetti({
          particleCount: 1,
          startVelocity: 0,
          ticks: ticks,
          origin: {
            x: Math.random(),
            y: Math.random() * skew - 0.2
          },
          colors: ['#ffffff', '#e6f2ff', '#ccebff'],
          shapes: ['circle'],
          gravity: randomInRange(0.4, 0.6),
          scalar: randomInRange(0.4, 0.6),
          drift: randomInRange(-0.4, 0.4)
        });
      }

      if (timeLeft > 0) {
        requestAnimationFrame(frame);
      } else {
        // Restart snowfall
        setTimeout(() => this.startSnowfall(), 100);
      }
    };

    frame();
  }
  */
  // ==================== END LEGACY CHRISTMAS CODE ====================

}
